import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function Copyright() {
    return (
      <Typography variant="body2" color="text.secondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://realstarpremier.com/">
        <strong>Realstar Premier Group</strong>
        </Link>{'  '}
        {'2024'}
        {'.'}
      </Typography>
    );
  }

  export default Copyright;